import React, { useState, useEffect } from "react";
import { commentIcon } from "../../../assets/images";
import { Button } from "reactstrap";
import { CircularAvatar } from "../../commons";
import EstimateJobUserView from "../../../screens/Scheduling/UserView/EstimateJobUserView";

type AppProps = {
  data: any;
  success: null | number;
  handleupdateAction: any;
  history: any;
  token: string | null;
  dispatchAddSchedulingEstimateAction: (data: any) => void;
  getAction?: string | undefined;
  setGetAction?: any;
};
const style = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
};

const ApprovedReuest = ({
  success,
  data,
  handleupdateAction,
  history,
  token,
  dispatchAddSchedulingEstimateAction,
  getAction,
  setGetAction,
}: AppProps) => {
  const [showSchedulingEstimateModal, setShowSchedulingEstimateModal] =
    useState<boolean>(false);
  const [handleLable, setHandleLable] = useState("");

  const [update, setUpdate] = useState({});

  const handleUpdate = () => {
    setGetAction("update");
    setShowSchedulingEstimateModal(!showSchedulingEstimateModal);
  };

  const handleReject = () => {
    setHandleLable("comment");
    setGetAction("reject");
    setShowSchedulingEstimateModal(!showSchedulingEstimateModal);
  };

  const handleToggleEstimateModal = () => {
    setShowSchedulingEstimateModal(!showSchedulingEstimateModal);
    setGetAction("");
  };

  const handleApproved = () => {
    setGetAction("approved");
    handleupdateAction(data?._id, "approved");
  };

  useEffect(() => {
    if (data?.job && Object?.keys(data?.job)?.length) {
      let finalData = {
        _id: data?._id,
        job_id: data?.job?.job_id,
        job_description: data?.job?.job_description,
        period_ended: data?.job?.period_ended,
        target_start_date: data?.job?.target_start_date,
        target_end_date: data?.job?.target_end_date,
        job_type: data?.job?.job_type,
        schedule_status: data?.schedule_status,
        estimate_data: data?.estimate_data,
        created_by: data?.created_by,
        total_hours: data?.total_hours,
        client_code: data?.client_code,
        client_name: data?.client_name,
      };
      setUpdate(finalData);
    } else {
      let finalData = {
        future_job: data?.future_job?.future_job_id,
        job_id: "",
        job_description: data?.future_job?.job_description,
        period_ended: data?.future_job?.period_ended,
        target_start_date: data?.future_job?.target_start_date,
        target_end_date: data?.future_job?.target_end_date,
        job_type: data?.future_job?.job_type,
        schedule_status: data?.schedule_status,
        estimate_data: data?.estimate_data,
        created_by: data?.created_by,
        total_hours: data?.total_hours,
        action: data?._id,
        future: "future",
        _id: data?._id,
        client_code: data?.client_code,
        client_name: data?.client_name,
      };
      setUpdate(finalData);
    }
  }, [data]);

  return (
    <>
      <div style={style}>
        <div style={style}>
          <div style={{ fontSize: "17px", fontWeight: 500 }}>
            Estimation provided by
          </div>
          <div style={style} className="ml-3">
            <div>
              <CircularAvatar
                name={data?.created_by?.name}
                image={
                  data?.created_by?.profile_pic?.file_url &&
                  data?.created_by?.profile_pic?.file_url
                }
              />
            </div>
            <div className="ml-2">
              {data?.created_by?.name}
              <div
                style={{
                  fontSize: "12px",
                  fontWeight: 500,
                  color: "#6e7491",
                }}
              >
                {`${data?.created_by?.job_title ? data?.created_by?.job_title : ""} ${data?.created_by?.department ? "," : ""
                  }${data?.created_by?.department ? data?.created_by?.department : ""}`}
              </div>
            </div>
          </div>
        </div>

        <div>
          <div style={{ ...style, justifyContent: "center", gap: "10px" }}>
            {/* <img src={commentIcon} alt="comment-icon" /> */}
            <button
              className="btn btn-outline-secondary"
              onClick={handleUpdate}
              disabled={data?.schedule_status === 3}
            >
              Review
            </button>
            {/* Commented for future use */}
            {/* <button className="btn btn-primary" onClick={handleApproved} disabled={data?.schedule_status===3}>Approve</button> */}
            <button
              className="btn btn-outline-danger"
              onClick={handleReject}
              disabled={data?.schedule_status === 3}
            >
              Reject
            </button>
          </div>
        </div>
      </div>
      {showSchedulingEstimateModal && (
        <EstimateJobUserView
          success={success}
          modal={showSchedulingEstimateModal}
          toggleModal={handleToggleEstimateModal}
          showSchedulingEstimateData={update}
          handleLable={handleLable}
          handleupdateAction={handleupdateAction}
          getAction={getAction}
          history={history}
          update={"update"}
          token={token}
          reEstimateDataList={data}
          showSchedulingEstimateModal={showSchedulingEstimateModal}
          setShowSchedulingEstimateModal={setShowSchedulingEstimateModal}
          dispatchAddSchedulingEstimateAction={
            dispatchAddSchedulingEstimateAction
          }
          setHandleLable={setHandleLable}
        />
      )}
    </>
  );
};

export default ApprovedReuest;
